module.exports = __webpack_public_path__ + "static/gallery46-b24cd23eccdff588de19037a47277989.png";